// extracted by mini-css-extract-plugin
export var PageTransition = "q_D";
export var aniBgLoading = "q_f";
export var aniSpin = "q_d";
export var overlay = "q_F";